<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.coupons')"
                :pgIcon="'bx bx-money'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=9

                :hasSearchFilter=true
                :hasDateFilter=true
                :hasStatusFilter=true
                :hasLecturerFilter=true

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=true
                :HasExport=true
                :hasShowEntries=true

                :lblSearch="$t('app.search')"

                :fields="{
                    'id': 'id',
                    'title': 'title',
                    'count': 'count',
                    'value': 'value',
                    'date': 'date',
                }"

                :hasTitle=true
                :title="$t('view.coupon_title')"

                :hasModule=true
                :module="$t('app.module')"

                :hasCoupons=true
                :coupons="$t('app.coupons')"

                :hasPercentage=true
                :percentage="$t('app.percentage')"

                :hasDate=true
                :hasStatus=true
                :hasActions=true
                :hasDeleteButton=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'coupons',
        }
    },
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            this.addNew = event;
        },
    },
}
</script>
